import { screenIs } from 'lib-node-question-builder/utils';

export const NEW_SUBORDINATE_FINANCING_DROPDOWN = [
  { value: 0, label: '' },
  { value: 1, label: 'Any payment required within first 5 years' },
  { value: 2, label: 'Payments deferred 5 or more years and fully forgiven' },
  {
    value: 3,
    label: 'Payments deferred 5 or more years and not fully forgiven',
  },
];

export const READONLY_CONDITION = screenIs('isWriteAccessDisabled', true);
